export const WALKTHROUGH_STATES = {
  POSITION: 1,
  OPENINGS: 2,
  DATEANDTIME: 3,
  LOCATION: 4,
  SHIFT_TITLE: 9,
  SHIFT_DESCRIPTION: 10,
  ARRIVAL_INSTRUCTIONS: 19,
  SUGGESTED_ATTIRE: 20,
  COMPANY_INFO: 11,
  QUESTIONS: 12,
  REQUIREMENTS: 13,
  HIRE: 14,
  PAY: 15,
  PREVIEW: 16,
};

export const SCHEDULING_INTERVALS = ["1 Week", "2 Weeks", "3 Weeks", "4 Weeks", "5 Weeks", "6 Weeks", "7 Weeks", "8 Weeks", "9 Weeks", "10 Weeks"];

export const TRIGGER_NEXT_EVENT_NAME = "20300402302";

export const UPDATE_WORKFLOW_EVENT_NAME = "2030023434302";

export const DRESS_CODE_DEFAULT =
  "We recommend wearing clothing without logos. Wear something that is durable that you feel comfortable in when performing manual labor. Close toed shoes are appropriate.";

export const CUSTOM_LOCATIONS = {
  features: [
    {
      type: "Feature",
      place_name: "2 Freedom Court, Durham, North Carolina 27703, United States",
      properties: {
        title: "2 Freedom Court, Durham, North Carolina 27703, United States",
      },
      geometry: {
        coordinates: [-78.8441952, 35.9099926],
        type: "Point",
      },
      address: "2",
      text: "Freedom Court",
      context: [
        {
          id: "postcode",
          text: "27703",
        },
        {
          id: "place",
          text: "Durham",
        },
        {
          id: "region",
          text: "North Carolina",
        },
      ],
    },
    {
      type: "Feature",
      place_name: "Forest Service Rd 711, Topton, NC 28781, USA",
      properties: {
        title: "Forest Service Rd 711, Topton, NC 28781, USA",
      },
      geometry: {
        coordinates: [-83.5999282, 35.1954888],
        type: "Point",
      },
      address: "711",
      text: "Forest Service Rd",
      context: [
        {
          id: "postcode",
          text: "28781",
        },
        {
          id: "place",
          text: "Topton",
        },
        {
          id: "region",
          text: "North Carolina",
        },
      ],
    },
    {
      type: "Feature",
      place_name: "1828 W Ferdinand Street, Chicago, Illinois 60622, United States",
      properties: {
        title: "1828 W Ferdinand Street, Chicago, Illinois 60622, United States",
      },
      geometry: {
        coordinates: [-87.6728924, 41.8905761],
        type: "Point",
      },
      address: "1828",
      text: "W Ferdinand Street",
      context: [
        {
          id: "postcode",
          text: "60622",
        },
        {
          id: "place",
          text: "Chicago",
        },
        {
          id: "region",
          text: "Illinois",
        },
      ],
    },
    {
      type: "Feature",
      place_name: "1 Ranchland Substation, Cisco, TX 76437, United States",
      properties: {
        title: "1 Ranchland Substation, Cisco, TX 76437, United States",
      },
      geometry: {
        coordinates: [-99.1640619, 32.3068369],
        type: "Point",
      },
      address: "1",
      text: "Ranchland Substation",
      context: [
        {
          id: "postcode",
          text: "76437",
        },
        {
          id: "place",
          text: "Cisco",
        },
        {
          id: "region",
          text: "Texas",
        },
      ],
    },
    {
      type: "Feature",
      place_name: "21460 Austell Pond Dr, Porter, TX 77365, United States",
      properties: {
        title: "21460 Austell Pond Dr, Porter, TX 77365, United States",
      },
      geometry: {
        coordinates: [-95.262806, 30.103458],
        type: "Point",
      },
      address: "21460",
      text: "Austell Pond Dr",
      context: [
        {
          id: "postcode",
          text: "77365",
        },
        {
          id: "place",
          text: "Porter",
        },
        {
          id: "region",
          text: "Texas",
        },
      ],
    },
    {
      type: "Feature",
      place_name: "2041 Northwest 12th Avenue Miami, Florida 33127, United States",
      properties: {
        title: "2041 Northwest 12th Avenue Miami, Florida 33127, United States",
      },
      geometry: {
        coordinates: [-80.21453, 25.79586],
        type: "Point",
      },
      address: "2041",
      text: "Northwest 12th Avenue",
      context: [
        {
          id: "postcode",
          text: "33127",
        },
        {
          id: "place",
          text: "Miami",
        },
        {
          id: "region",
          text: "Florida",
        },
      ],
    },
    {
      type: "Feature",
      place_name: "1016 Madison Square, Madison, TN 37115, United States",
      properties: {
        title: "1016 Madison Square, Madison, TN 37115, United States",
      },
      geometry: {
        coordinates: [-86.7157287, 36.2553709],
        type: "Point",
      },
      address: "1016",
      text: "Madison Square",
      context: [
        {
          id: "postcode",
          text: "37115",
        },
        {
          id: "place",
          text: "Madison",
        },
        {
          id: "region",
          text: "Tennessee",
        },
      ],
    },
    {
      type: "Feature",
      place_name: "2 Freedom Ct Durham, NC 27703, United States",
      properties: {
        title: "2 Freedom Ct Durham, NC 27703, United States",
      },
      geometry: {
        coordinates: [-78.8441952, 35.9099926],
        type: "Point",
      },
      address: "2",
      text: "Freedom Ct",
      context: [
        {
          id: "postcode",
          text: "27703",
        },
        {
          id: "place",
          text: "Durham",
        },
        {
          id: "region",
          text: "North Carolina",
        },
      ],
    },
    {
      type: "Feature",
      place_name: "3700 Havana St, Denver, CO 80239, United States",
      properties: {
        title: "3700 Havana St, Denver, CO 80239, United States",
      },
      geometry: {
        coordinates: [-104.8644976, 39.7702094],
        type: "Point",
      },
      address: "3700",
      text: "Havana St",
      context: [
        {
          id: "postcode",
          text: "80239",
        },
        {
          id: "place",
          text: "Denver",
        },
        {
          id: "region",
          text: "Colorado",
        },
      ],
    },
    {
      type: "Feature",
      place_name: "2100 Foxhall Rd NW Washington DC 20007",
      properties: {
        title: "2100 Foxhall Rd NW Washington DC 20007",
      },
      geometry: {
        coordinates: [-77.03, 38.89],
        type: "Point",
      },
      address: "2100",
      text: "Foxhall Rd",
      context: [
        {
          id: "postcode",
          text: "20007",
        },
        {
          id: "place",
          text: "Washington",
        },
        {
          id: "region",
          text: "DC",
        },
      ],
    },
  ],
  type: "FeatureCollection",
};



// WEBPACK FOOTER //
// ./client/app/scenes/postashiftwalkthrough/variables.js